<template>
    <div id="soil-chart-container">

        <div id="soil-chart-chart-header" class="row justify-content-between">
            <div class="col">
                <h5>{{ $t($route.name + '.soilMoistureChartTitle') }}</h5>
            </div>
            <div id="non-printable-header" class="col" style="padding-bottom: 10px;" data-html2canvas-ignore="true">
                <div class="row justify-content-end" style="padding-right: 50px;">
                    <button class="btn btn-sm btn-dark" v-on:click="downloadDataset()">
                        {{ $t($route.name + '.downloadDataset') }}
                    </button>
                    <div class="dropdown">
                        <button class="btn btn-info btn-sm dropdown-toggle" type="button" data-toggle="dropdown"
                            data-bs-auto-close="false" aria-expanded="false" v-on:click="onDropdownClick">
                            <i class="bi bi-funnel"></i>
                        </button>
                        <ul class="dropdown-menu" v-on:click="(e) => { e.stopPropagation(); }">
                            <li>
                                <a class="dropdown-item" v-on:click="dropdownOptions.soil1 = !dropdownOptions.soil1">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox"
                                            v-on:change="dropdownOptions.soil1 = !dropdownOptions.soil1"
                                            :checked="dropdownOptions.soil1" />
                                        <label class="form-check-label" for="Checkme1">{{ splitDataset.soil_1_meter.name
                                        }}</label>
                                    </div>
                                </a>
                            </li>
                            <li v-if="splitDataset.soil_2_meter != undefined">
                                <a class="dropdown-item" v-on:click="dropdownOptions.soil2 = !dropdownOptions.soil2">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox"
                                            v-on:change="dropdownOptions.soil2 = !dropdownOptions.soil2"
                                            :checked="dropdownOptions.soil2" />
                                        <label class="form-check-label" for="Checkme1">{{ splitDataset.soil_2_meter.name
                                        }}</label>
                                    </div>
                                </a>
                            </li>
                            <li v-if="splitDataset.soil_3_meter != undefined">
                                <a class="dropdown-item" v-on:click="dropdownOptions.soil3 = !dropdownOptions.soil3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox"
                                            v-on:change="dropdownOptions.soil3 = !dropdownOptions.soil3"
                                            :checked="dropdownOptions.soil3" />
                                        <label class="form-check-label" for="Checkme1">{{ splitDataset.soil_3_meter.name
                                        }}</label>
                                    </div>
                                </a>
                            </li>
                            <li v-if="(analysisData.cc != undefined) && (analysisData.pmp != undefined) && (analysisData.pr != undefined)">
                                <a class="dropdown-item" v-on:click="dropdownOptions.analysis = !dropdownOptions.analysis">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox"
                                            v-on:change="dropdownOptions.analysis = !dropdownOptions.analysis"
                                            :checked="dropdownOptions.analysis" />
                                        <label class="form-check-label" for="Checkme1">{{ $t($route.name+'.dropdownAnalysisOption') }}</label>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <hr class="dropdown-divider" />
                            </li>
                            <li>
                                <a class="dropdown-item">
                                    <button class="btn btn-primary" v-on:click="onFilter()">Filter</button>
                                </a>
                            </li>

                        </ul>
                    </div>


                    <button class="btn btn-light btn-sm" v-on:click="resetChartZoom()">Reset zoom</button>
                </div>
            </div>
        </div>
        <div class="row chartWithOverlaySoil">
            <div id="soil-chart" class="col" v-if="ready">
                <LineAndStackedAreaChart :chart-data="dataset" :reset-zoom-event="resetZoomEvent" :minValue="minValue" :maxValue="maxValue"
                    :absMinSerieOne="1.0" :areaStyleHeaders="styles" ref="soilProbeChart" />
            </div>
            <div class="overlaySoil" v-if="analysisType!=''">
                <span v-if="analysisType=='silva'"><b>Silva et. al. 1988</b></span>
                <span v-if="analysisType=='calavia'"><b>Calavia et. al. 2023</b></span>
            </div>
        </div>
        <div id="soil-probes-footer" class="row justify-content-center">
            <div class="col-sm-3">
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <div class="input-group-text bg-secondary border border-light text-dark" id="basic-addon1">CC</div>
                    </div>
                    <input type="text" class="form-control border border-light text-dark text-center" :value="analysisData.cc"
                        aria-label="Input group example" aria-describedby="btnGroupAddon" style="padding-left: 10px;">
                    <div class="input-group-append" id="basic-addon2">
                        <span class="input-group-text bg-secondary border border-light text-dark">%</span>
                    </div>

                </div>
            </div>
            <div class="col-sm-3">
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <div class="input-group-text bg-secondary border border-light text-dark" id="basic-addon1">PMP</div>
                    </div>
                    <input type="text" class="form-control border border-light text-dark text-center" :value="analysisData.pmp"
                        aria-label="Input group example" aria-describedby="btnGroupAddon" style="padding-left: 10px;">
                    <div class="input-group-append" id="basic-addon2">
                        <span class="input-group-text bg-secondary border border-light text-dark">%</span>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <div class="input-group-text bg-secondary border border-light text-dark" id="basic-addon1">CRAD</div>
                    </div>
                    <input type="text" class="form-control border border-light text-dark text-center" :value="analysisData.crad"
                        aria-label="Input group example" aria-describedby="btnGroupAddon" style="padding-left: 10px;">
                    <div class="input-group-append" id="basic-addon2">
                        <span class="input-group-text bg-secondary border border-light text-dark">%</span>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <div class="input-group-text bg-secondary border border-light text-dark" id="basic-addon1">PR</div>
                    </div>
                    <input type="text" class="form-control border border-light text-dark text-center" :value="analysisData.pr"
                        aria-label="Input group example" aria-describedby="btnGroupAddon" style="padding-left: 10px;">
                    <div class="input-group-append" id="basic-addon2">
                        <span class="input-group-text bg-secondary border border-light text-dark">%</span>
                    </div>
                </div>
            </div>
        </div>
        <div id="soil-probes-footer-printable" hidden>
            <p><small v-if="analysisType=='silva'"><b>Silva et. al. 1988</b></small><small v-if="analysisType=='calavia'"><b>Calavia et. al. 2023</b></small>&nbsp;/&nbsp;<small><b>CC</b>: {{ analysisData.cc }} %</small>&nbsp;<small><b>PMP</b>: {{ analysisData.pmp }} %</small>&nbsp;<small><b>CRAD</b>: {{ analysisData.crad }} %</small>&nbsp;<small><b>PR</b>: {{ analysisData.pr }} %</small></p>
        </div>
    </div>
</template>
<script>
import LineAndStackedAreaChart from "@/components/Charts/LineAndStackedAreaChart.vue"
import createCSV from "@/parsers/csv.creator.js"

export default {
    name: "SoilProbesChart",
    components: {
        LineAndStackedAreaChart
    },
    expose: ['getChartElement'],
    props: {
        splitDataset: Object,
        analysisData: Object
    },
    data() {
        return {
            resetZoomEvent: false,
            ready: false,
            soil1: true,
            soil2: true,
            soil3: true,
            analysis: false,
            maxValue: 1,
            minValue: 0,
            analysisType: "",
            styles: [],
            dropdownOptions: {
                soil1: true,
                soil2: true,
                soil3: true,
                analysis: false,
            }
        }
    },
    mounted() {
        if (this.splitDataset.soil_2_meter == undefined) {
            this.soil2 = false;
            this.dropdownOptions.soil2 = false;
        }
        if (this.splitDataset.soil_3_meter == undefined) {
            this.soil3 = false;
            this.dropdownOptions.soil3 = false;
        }
        this.flattenDataset();
        this.ready = true;
    },
    methods: {
        resetChartZoom() {
            this.resetZoomEvent = true;
            this.$nextTick(() => {
                this.resetZoomEvent = false;
            })
        },
        flattenDataset() {
            const data = []
            this.soil1 = this.dropdownOptions.soil1;
            this.soil2 = this.dropdownOptions.soil2;
            this.soil3 = this.dropdownOptions.soil3;
            this.analysis = this.dropdownOptions.analysis;

            const styles = []
            let serie;
            const headers = [this.splitDataset.datetime.name]
            if (
                !this.soil1 &&
                !this.soil2 &&
                !this.soil3
            ) {
                headers.push(this.$t(this.$route.name + ".noDataSelected"));
                data.push(headers)
                data.push([this.splitDataset.datetime.dataset[0], 0.0]);
            } else {
                if (this.soil1) {
                    headers.push(this.splitDataset.soil_1_meter.name)
                    serie = {color: 'green'};
                    if(this.unflattenned){
                        serie.targetAxisIndex = 0;
                    }
                    styles.push(serie)
                }
                if (this.soil2) {
                    headers.push(this.splitDataset.soil_2_meter.name)
                    serie = {color: 'orange'};
                    if(this.unflattenned){
                        serie.targetAxisIndex = 1;
                    }
                    styles.push(serie)
                }
                if (this.soil3) {
                    headers.push(this.splitDataset.soil_3_meter.name)
                    styles.push({color: 'red'})
                }
                if (this.analysis) {
                    this.analysisType = this.analysisData.type;
                    headers.push( this.$t(this.$route.name+'.legendWaterNotAvailable') )
                    styles.push({type: "area", lineWidth: 0, areaOpacity: 0.2, color: 'red', enableInteractivity: false})
                    headers.push( this.$t(this.$route.name+'.legendWaterAvailable') )
                    styles.push({type: "area", lineWidth: 0, areaOpacity: 0.3, color: 'orange', enableInteractivity: false})
                    headers.push( this.$t(this.$route.name+'.legendWaterEasyAvailable') )
                    styles.push({type: "area", lineWidth: 0, areaOpacity: 0.3, color: 'green', enableInteractivity: false})
                    headers.push("fill")
                    styles.push({type: "area", lineWidth: 0, areaOpacity: 0.2, color: 'red', enableInteractivity: false, visibleInLegend: false})
                
                    
                }else{
                    this.analysisType = "";
                }


                data.push(headers)
                let concatDataset = [];
                if(this.splitDataset.soil_1_meter != null){
                    concatDataset = concatDataset.concat(this.splitDataset.soil_1_meter.dataset);
                }
                if(this.splitDataset.soil_2_meter != null){
                    concatDataset = concatDataset.concat(this.splitDataset.soil_2_meter.dataset);
                }
                if(this.splitDataset.soil_3_meter != null){
                    concatDataset = concatDataset.concat(this.splitDataset.soil_3_meter.dataset);
                }
                this.maxValue = Math.max.apply(Math, concatDataset) + 0.05;
                this.maxValue = Math.round(this.maxValue * 10) / 10;
                
                this.minValue = Math.min.apply(Math, concatDataset);
                if (this.minValue >= 0.05){
                    this.minValue -= 0.05;
                }
                let lastValidValueSoil1;
                let lastValidValueSoil2;
                let lastValidValueSoil3;
                for (let i = 0; i < this.splitDataset.datetime.dataset.length; i++) {
                    const row = [this.splitDataset.datetime.dataset[i]]

                    if (this.soil1) {
                        if(parseFloat(this.splitDataset.soil_1_meter.dataset[i]) < 0.05){
                            row.push(0.1);
                            lastValidValueSoil1 = 0.1;
                        }else if(parseFloat(this.splitDataset.soil_1_meter.dataset[i]) > 1.0){
                            row.push(lastValidValueSoil1)
                        }else{
                            row.push(this.splitDataset.soil_1_meter.dataset[i])
                            lastValidValueSoil1 = this.splitDataset.soil_1_meter.dataset[i];
                        }
                    }

                    if (this.soil2) {
                        if(parseFloat(this.splitDataset.soil_2_meter.dataset[i]) < 0.05){
                            row.push(0.1);
                            lastValidValueSoil2 = 0.1;
                        }else if(parseFloat(this.splitDataset.soil_2_meter.dataset[i]) > 1.0){
                            row.push(lastValidValueSoil2)
                        }else{
                            row.push(this.splitDataset.soil_2_meter.dataset[i])
                            lastValidValueSoil2 = this.splitDataset.soil_2_meter.dataset[i];
                        }
                    }

                    if (this.soil3) {
                        if(parseFloat(this.splitDataset.soil_3_meter.dataset[i]) < 0.05){
                            row.push(0.1);
                            lastValidValueSoil3 = 0.1;
                        }else if(parseFloat(this.splitDataset.soil_3_meter.dataset[i]) > 1.0){
                            row.push(lastValidValueSoil3)
                        }else{
                            row.push(this.splitDataset.soil_3_meter.dataset[i])
                            lastValidValueSoil3 = this.splitDataset.soil_3_meter.dataset[i];
                        }
                    }
                    

                    if (this.analysis) {
                        const dtPmp = this.analysisData.pmp / 100;
                        const dtPr = (this.analysisData.pr / 100) - dtPmp; 
                        const dtCc = (this.analysisData.cc / 100) - dtPr - dtPmp;
                        const dtMax = this.maxValue - dtCc - dtPr - dtPmp;
                        row.push(dtPmp)
                        row.push(dtPr)
                        row.push(dtCc)
                        row.push(dtMax)
                    }

                    data.push(row)
                }
                
            }
            this.styles = styles;
            this.dataset = data;
        },
        onDropdownClick() {
            this.dropdownOptions.soil1 = this.soil1;
            this.dropdownOptions.soil2 = this.soil2;
            this.dropdownOptions.soil3 = this.soil3;
            this.dropdownOptions.analysis = this.analysis;
        },
        onFilter() {
            this.flattenDataset();
            this.resetChartZoom();
        },
        async getChartElement(width, height) {

            const imgDiv = document.getElementById("soil-chart")
            imgDiv.setAttribute("class", "printable-chart")
            imgDiv.classList = "printable-chart"

            await this.resizeAndWaitForResizeFinish()

            const img = this.$refs.soilProbeChart.getChartAsImage()
            imgDiv.setAttribute("class", "col")
            imgDiv.classList = "col"

            await this.resizeAndWaitForResizeFinish()

            const chartHeaderOriginal = document.getElementById('soil-chart-chart-header')
            var noPrintableHeader = document.getElementById("non-printable-header");
            noPrintableHeader.hidden = true;
            
            const headerDiv = document.createElement("div")
            headerDiv.setAttribute("class", "col")
            headerDiv.classList = "col"

            const chartHeader = chartHeaderOriginal.cloneNode(true)
            noPrintableHeader.hidden = false;
            const chartFooter = document.getElementById('soil-probes-footer-printable').cloneNode(true)
            chartFooter.hidden = false;
            
            headerDiv.appendChild(chartFooter)
            chartHeader.appendChild(headerDiv)

            const superDiv = document.createElement('div')
            superDiv.id = "super-div"

            const chartDiv = document.createElement('div')
            chartDiv.style.display = 'inline-block'
            chartDiv.style.width = width
            chartDiv.style.height = height

            chartDiv.style.backgroundImage = "url(" + img + ")"
            chartDiv.style.backgroundRepeat = "no-repeat"
            chartDiv.style.backgroundSize = "contain"

            superDiv.appendChild(chartHeader)
            superDiv.appendChild(chartDiv)
            

            return superDiv
        },

        async resizeAndWaitForResizeFinish() {
            const TIME_TO_RESIZE = 200
            const resizeEvent = window.document.createEvent('UIEvents');
            resizeEvent.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(resizeEvent);
            window.dispatchEvent(new Event('resize'));

            await new Promise(resolve => {
                const interval = setInterval(() => {
                    resolve();
                    clearInterval(interval);
                }, TIME_TO_RESIZE);
            });
        },

        async test(){
            document.write((await this.getChartElement('1076px', '250px')).innerHTML);
        },
        downloadDataset(){
            createCSV(this.dataset, "SoilMoistureDataset");
        }
    }
}

</script>
<style scoped>
.printable-chart {
    display: inline;
    max-width: 38.5cm !important;
    max-width: 38.5cm !important;
    /* Assuming 10cm of margin + 1 cm more to be safe */
}
.chartWithOverlaySoil {
    position: relative;
}

.overlaySoil {
    width: 170px;
    height: 25px;
    text-align: center;
    border: 1px solid black;
    border-radius: 10px;
    color: black;
    background-color: aliceblue;
    position: absolute;
    top: 80%;   /* chartArea top  */
    left: 5%; /* chartArea left */
}


</style>